<div class="raque-nav">
    <div class="container">
        <nav class="navbar navbar-expand-md navbar-light">
            <a class="navbar-brand" routerLink="/">
                <img src="assets/img/black-logo.png" alt="logo">
            </a>
            <div class="collapse navbar-collapse mean-menu">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a routerLink="/" class="nav-link" [ngClass]="{'active':pageIndex === 0}">{{home}}</a>
                    </li>

                    <li class="nav-item"><a href="javascript:;" class="nav-link"
                            [ngClass]="{'active':pageIndex === 1}">{{aboutEdu}} <i class='bx bx-chevron-down'></i></a>
                        <ul class="dropdown-menu">
                            <li class="nav-item"><a routerLink="/other/profile" class="nav-link">{{profile}}</a></li>

                            <li class="nav-item"><a routerLink="/instructors" class="nav-link">{{instructor}}</a></li>

                            <li class="nav-item"><a routerLink="/partners" class="nav-link">{{partner}}</a>
                            </li>

                            <li class="nav-item"><a routerLink="/other/feedback" class="nav-link">{{feedback}}</a>
                            </li>

                            <li class="nav-item"><a routerLink="/other/faq" class="nav-link">{{faq}}</a>
                            </li>

                            <li class="nav-item"><a routerLink="/other/user-guide" class="nav-link">{{userGuide}}</a>
                            </li>

                        </ul>
                    </li>

                    <li class="nav-item"><a routerLink="/courses" class="nav-link"
                            [ngClass]="{'active':pageIndex === 2}">{{courses}}</a>

                    </li>

                    <li class="nav-item">
                        <a routerLink="/lessons" class="nav-link"
                            [ngClass]="{'active':pageIndex === 3}">{{englishLesson}}
                            <i class='bx bx-chevron-down'></i>
                        </a>
                        <ul class="dropdown-menu">
                            <li *ngFor="let lesson of lessons" class="nav-item">
                                <a href="javascript:;" class="nav-link"
                                    (click)="onRouteToCourses(lesson.id)">{{translate(lesson.nameEn,lesson.nameKh)}} <i
                                        class='bx bx-chevron-right'></i></a>
                                <ul class="dropdown-menu">
                                    <li *ngFor="let level of lesson.levels" class="nav-item">
                                        <a (click)="onRouteToCourses(lesson.id,level.id)"
                                            class="nav-link">{{translate(level.titleEn,level.titleKh)}}</a>
                                    </li>
                                </ul>
                            </li>

                        </ul>
                    </li>

                    <li class="nav-item"><a routerLink="/knowledges" class="nav-link"
                            [ngClass]="{'active':pageIndex === 4}">{{knowledge}}</a>

                    </li>

                    <li class="nav-item"><a routerLink="/contact" class="nav-link"
                            [ngClass]="{'active':pageIndex === 5}">{{contact}}</a></li>
                    <li class="nav-item"><a routerLink="/phrasalverbs" class="nav-link"
                            [ngClass]="{'active':pageIndex === 6}">{{dictionary}}</a></li>
                </ul>

                <div class="others-option">
                    <div class="dropdown language-switcher d-inline-block">
                        <button (click)="onSwitchLanguage()" class="dropdown-toggle" type="button">

                            <img src="{{flagImage}}" class="shadow" alt="image">
                        </button>

                    </div>

                    <div class="search-box d-inline-block">
                        <i class='bx bx-search'></i>
                    </div>
                </div>
            </div>

        </nav>
    </div>
</div>